interface WorkflowStepContext {
  step_label?: string | null;
  validator_role?: string | null;
}

export const isWarekWorkflowStep = (step?: WorkflowStepContext | null): boolean => {
  const stepLabel = (step?.step_label || '').toLowerCase();
  const validatorRole = (step?.validator_role || '').toLowerCase();

  return stepLabel.includes('warek')
    || stepLabel.includes('wakil rektor')
    || validatorRole.startsWith('wakil_rektor_');
};
